import { CardContent, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import DeleteIcon from "@material-ui/icons/Delete";
import React, { useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import { _get, _post } from "../../../Api";

export default function HandheldAccounts(props) {
  const merchant = props.merchant;
  const [handheldUsers, setHandheldUsers] = React.useState(null);
  const merchantId = merchant.id;
  const setAddAccountDialogType = props.setAddAccountType;
  const setRemoveAccountDialogType = props.setRemoveAccountType;
  const setSelectedAccount = props.setSelectedAccount;

  function gatherHandheldUsers(users) {
    const map = new Map();
    users.forEach((user) => {
      map.set(user.username, {
        username: user.username,
        handheldUserId: user.id,
        inhouse: user.sp_merchants.length > 0,
        takeaway: user.ta_merchants.length > 0,
        use_menu_tags: user.use_menu_tags === 1,
      });
    });
    return map;
  }

  useEffect(() => {
    function getHandheldUsers() {
      _get("/nova/merchant/" + merchantId + "/handheld")
        .then((response) => {
          setHandheldUsers(gatherHandheldUsers(response.data));
        })
        .catch((e) => {
          console.log(e);
        });
    }

    if (merchant && !handheldUsers) {
      getHandheldUsers();
    }
  }, [merchant, handheldUsers, merchantId]);

  function updateHandheldState(response) {
    const user = response.data ? response.data : response;
    handheldUsers.set(user.username, {
      username: user.username,
      handheldUserId: user.id,
      inhouse: user.sp_merchants.length > 0,
      takeaway: user.ta_merchants.length > 0,
      use_menu_tags: user.use_menu_tags === 1,
    });
    const map = new Map();
    handheldUsers.forEach((handheldUser, username) => {
      map.set(username, handheldUser);
    });
    setHandheldUsers(map);
  }

  function changePassword(event, handheldUserId) {
    const password = event.target.value;
    if (!!password === false) {
      toast.error("Password was not changed.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/handheld/" + handheldUserId, {
      password: event.target.value,
    })
      .then((response) => {
        toast.success("Password changed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        updateHandheldState(response);
      })
      .catch((e) => {
        toast.error("Password could not be changed.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function changeCheckbox(event, type, username, handheldUserId) {
    const data =
      type === "inhouse"
        ? {
            inhouse: event.target.checked,
          }
        : type === "takeaway"
        ? {
            takeaway: event.target.checked,
          }
        : type === "use_menu_tags"
        ? {
            use_menu_tags: event.target.checked,
          }
        : {};
    _post("/nova/merchant/" + merchantId + "/handheld/" + handheldUserId, data)
      .then((response) => {
        toast.success("Changed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        updateHandheldState(response);
      })
      .catch((e) => {
        toast.error("Handheld account type could not be changed.", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function removeUser(handheldUser) {
    setSelectedAccount(handheldUser);
    setRemoveAccountDialogType("handheld");
  }

  if (!handheldUsers) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container direction={"column"}>
      <Grid container direction={"row"} spacing={2}>
        <Grid item lg={6}>
          <Typography variant={"h4"}>Handheld</Typography>
        </Grid>
        <Grid item lg={6}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setAddAccountDialogType("handheld")}
          >
            Account
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ marginBottom: "20px" }} />
      <Grid container direction="column" spacing={4}>
        {[...handheldUsers.keys()].map((username) => {
          return (
            <Grid item key={username}>
              <Card>
                <CardContent>
                  <FormControl>
                    <FormGroup row>
                      <Typography style={{ margin: "1em" }} variant={"h5"}>
                        {username}
                      </Typography>
                    </FormGroup>
                    <FormGroup row>
                      <FormControlLabel
                        style={{ margin: "1em" }}
                        control={
                          <Checkbox
                            onChange={(e) => {
                              changeCheckbox(e, "inhouse", username, handheldUsers.get(username).handheldUserId);
                            }}
                            checked={handheldUsers.get(username).inhouse}
                          />
                        }
                        label={"Inhouse"}
                        labelPlacement={"top"}
                        username={username}
                      />
                      <FormControlLabel
                        style={{ margin: "1em" }}
                        control={<Checkbox />}
                        label={"Takeaway"}
                        labelPlacement={"top"}
                        username={username}
                        checked={handheldUsers.get(username).takeaway}
                        onChange={(e) => {
                          changeCheckbox(e, "takeaway", username, handheldUsers.get(username).handheldUserId);
                        }}
                      />
                      <FormControlLabel
                        style={{ margin: "1em" }}
                        control={<Checkbox />}
                        label={"gebruik menus"}
                        labelPlacement={"top"}
                        username={username}
                        checked={handheldUsers.get(username).use_menu_tags}
                        onChange={(e) => {
                          changeCheckbox(e, "use_menu_tags", username, handheldUsers.get(username).handheldUserId);
                        }}
                      />
                    </FormGroup>
                    <FormGroup row>
                      <Paper style={{ padding: "1em" }} variant="outlined">
                        <TextField
                          label="password"
                          onBlur={(e) => {
                            changePassword(e, handheldUsers.get(username).handheldUserId);
                          }}
                        />
                      </Paper>
                      <Button
                        style={{ margin: "1em" }}
                        startIcon={<DeleteIcon />}
                        onClick={() => removeUser(handheldUsers.get(username))}
                      />
                    </FormGroup>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}
